(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6426],{

/***/ 16426:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Content064": function() { return /* binding */ Content064; },
  "default": function() { return /* binding */ Content064_Content064; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/shared/components/index.js + 115 modules
var components = __webpack_require__(87900);
// EXTERNAL MODULE: ./src/shared/contexts/ViewMode/index.js + 5 modules
var ViewMode = __webpack_require__(32667);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/widgets/content/Content064/Content064.context.js

var WidgetContent = /*#__PURE__*/ (0,react.createContext)(null);
var useWidgetContent = function() {
    var data = (0,react.useContext)(WidgetContent);
    if (data === null) {
        throw new Error("Consumer of WidgetContent should be wrapped by WidgetProvider");
    }
    return data;
};

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_throw.mjs
function _throw(e) {
    throw e;
}
// EXTERNAL MODULE: ./src/features/translations/index.js + 3 modules
var translations = __webpack_require__(91929);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/widgets/content/Content064/ButtonAdd/ButtonAdd.module.scss
var ButtonAdd_module = __webpack_require__(98449);
var ButtonAdd_module_default = /*#__PURE__*/__webpack_require__.n(ButtonAdd_module);
;// CONCATENATED MODULE: ./src/components/widgets/content/Content064/ButtonAdd/ButtonAdd.jsx






var ButtonAdd = function(param) {
    var label = param.label, className = param.className;
    var t = (0,translations/* useTranslation */.$)().t;
    var ref = useWidgetContent(), isAddingDisabled = ref.isAddingDisabled, onOpen = ref.onOpen;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Action */.aU, {
        className: classnames_default()((ButtonAdd_module_default()).button, className),
        onClick: onOpen,
        disabled: isAddingDisabled,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                className: (ButtonAdd_module_default()).label,
                color: "brand",
                appearance: "bigger",
                children: label || t("add_program")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ButtonAdd_module_default()).circle,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                    name: "plus",
                    className: (ButtonAdd_module_default()).icon
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/widgets/content/Content064/ButtonAdd/index.js


// EXTERNAL MODULE: ./src/components/widgets/content/Content064/DefaultBlock/DefaultBlock.module.scss
var DefaultBlock_module = __webpack_require__(72304);
var DefaultBlock_module_default = /*#__PURE__*/__webpack_require__.n(DefaultBlock_module);
;// CONCATENATED MODULE: ./src/components/widgets/content/Content064/DefaultBlock/DefaultBlock.jsx








var DefaultBlock = function(param) {
    var param = param !== null ? param : _throw(new TypeError("Cannot destructure undefined"));
    var t = (0,translations/* useTranslation */.$)().t;
    var ref = useWidgetContent(), courses = ref.courses, onSelectCourse = ref.onSelectCourse;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (DefaultBlock_module_default()).wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (DefaultBlock_module_default()).blocks,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading3 */.aC, {
                    className: (DefaultBlock_module_default()).title,
                    color: "bold",
                    appearance: "bold",
                    children: t("default")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* RenderIf */.$b, {
                    viewMode: ViewMode/* VIEW_MODES.DESKTOP */.nY.DESKTOP,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (DefaultBlock_module_default()).list,
                        children: courses.map(function(param) {
                            var id = param.id, title = param.title, slug = param.slug;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Action */.aU, {
                                onClick: onSelectCourse(slug),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading3 */.aC, {
                                    className: (DefaultBlock_module_default()).item,
                                    color: "dark",
                                    appearance: "bold",
                                    children: title
                                })
                            }, id);
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* RenderIf */.$b, {
                    viewMode: ViewMode/* VIEW_MODES.MOBILE */.nY.MOBILE,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonAdd, {})
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/widgets/content/Content064/DefaultBlock/index.js


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./src/components/RichTextWidget/index.js + 11 modules
var RichTextWidget = __webpack_require__(14258);
// EXTERNAL MODULE: ./src/features/cms/index.js + 3 modules
var cms = __webpack_require__(49204);
// EXTERNAL MODULE: ./src/components/widgets/content/Content064/CourseSkeleton/CourseSkeleton.module.scss
var CourseSkeleton_module = __webpack_require__(30974);
var CourseSkeleton_module_default = /*#__PURE__*/__webpack_require__.n(CourseSkeleton_module);
;// CONCATENATED MODULE: ./src/components/widgets/content/Content064/CourseSkeleton/CourseSkeleton.jsx


var CourseSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (CourseSkeleton_module_default()).top,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (CourseSkeleton_module_default()).title
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (CourseSkeleton_module_default()).block,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (CourseSkeleton_module_default()).small,
                        children: " "
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (CourseSkeleton_module_default()).small
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (CourseSkeleton_module_default()).small
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (CourseSkeleton_module_default()).block,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (CourseSkeleton_module_default()).big,
                    children: " "
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (CourseSkeleton_module_default()).block,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (CourseSkeleton_module_default()).big,
                        children: " "
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (CourseSkeleton_module_default()).small
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (CourseSkeleton_module_default()).small
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (CourseSkeleton_module_default()).divider
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (CourseSkeleton_module_default()).big
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (CourseSkeleton_module_default()).small
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (CourseSkeleton_module_default()).small
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (CourseSkeleton_module_default()).block,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (CourseSkeleton_module_default()).small,
                        children: " "
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (CourseSkeleton_module_default()).small
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (CourseSkeleton_module_default()).small
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (CourseSkeleton_module_default()).block,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (CourseSkeleton_module_default()).big,
                    children: " "
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (CourseSkeleton_module_default()).block,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (CourseSkeleton_module_default()).small,
                        children: " "
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (CourseSkeleton_module_default()).small
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (CourseSkeleton_module_default()).small
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (CourseSkeleton_module_default()).block,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (CourseSkeleton_module_default()).small,
                        children: " "
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (CourseSkeleton_module_default()).small
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (CourseSkeleton_module_default()).small
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (CourseSkeleton_module_default()).link,
                children: " "
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/widgets/content/Content064/CourseSkeleton/index.js


// EXTERNAL MODULE: ./src/components/widgets/content/Content064/CourseInfo/CourseInfo.module.scss
var CourseInfo_module = __webpack_require__(42968);
var CourseInfo_module_default = /*#__PURE__*/__webpack_require__.n(CourseInfo_module);
;// CONCATENATED MODULE: ./src/components/widgets/content/Content064/CourseInfo/CourseInfo.jsx












var MobileLabel = function(param) {
    var label = param.label;
    var t = (0,translations/* useTranslation */.$)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* RenderIf */.$b, {
        viewMode: ViewMode/* VIEW_MODES.MOBILE */.nY.MOBILE,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
            className: (CourseInfo_module_default()).subtitle,
            color: "dark",
            children: t(label)
        })
    });
};
var HeadingsBlock = function(param) {
    var metrics = param.metrics, dataKey = param.dataKey;
    var t = (0,translations/* useTranslation */.$)().t;
    var text = metrics[dataKey];
    if (typeof metrics[dataKey] === "boolean") {
        text = metrics[dataKey] ? t("yes") : t("no");
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading5 */.by, {
        className: classnames_default()((0,_define_property/* default */.Z)({}, (CourseInfo_module_default()).empty, !Boolean(metrics[dataKey]))),
        children: text
    });
};
var RichTextBlock = function(param) {
    var metrics = param.metrics, dataKey = param.dataKey;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextWidget/* RichText */.H, {
        value: metrics === null || metrics === void 0 ? void 0 : metrics[dataKey],
        className: classnames_default()((0,_define_property/* default */.Z)({}, (CourseInfo_module_default()).empty, !Boolean(metrics === null || metrics === void 0 ? void 0 : metrics[dataKey])))
    });
};
var ProgramPrice = function(param) {
    var metrics = param.metrics, dataKey = param.dataKey;
    var ref;
    var ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: (ref1 = (ref = metrics[dataKey]) === null || ref === void 0 ? void 0 : ref.map(function(param) {
            var id = param.id, price = param.price, description = param.description, caption = param.caption;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (CourseInfo_module_default())["program-price__block"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading5 */.by, {
                        className: (CourseInfo_module_default())["program-price__title"],
                        children: price
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                        color: "dark",
                        appearance: "smaller",
                        children: description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                        color: "grey",
                        appearance: "smaller",
                        children: caption
                    })
                ]
            }, id);
        })) !== null && ref1 !== void 0 ? ref1 : "-"
    });
};
var ButtonView = function() {
    var isDesktop = (0,ViewMode/* useViewMode */.mJ)().isDesktop;
    var t = (0,translations/* useTranslation */.$)().t;
    return isDesktop ? t("more_about_program") : t("more");
};
var METRICS_MAPPING = {
    suitsTo: RichTextBlock,
    duration: HeadingsBlock,
    programPrice: ProgramPrice,
    advantages: RichTextBlock,
    internationalModule: HeadingsBlock,
    results: RichTextBlock,
    diploma: RichTextBlock
};
var CourseInfo = function(param) {
    var slug = param.slug;
    var t = (0,translations/* useTranslation */.$)().t;
    var ref = (0,react.useState)(null), error = ref[0], setError = ref[1];
    var ref1 = (0,react.useState)(true), pending = ref1[0], setPending = ref1[1];
    var ref2 = (0,react.useState)(null), data = ref2[0], setData = ref2[1];
    var ref3 = useWidgetContent(), locale = ref3.locale, onDeleteCourse = ref3.onDeleteCourse, availableMetrics = ref3.availableMetrics;
    var isDesktop = (0,ViewMode/* useViewMode */.mJ)().isDesktop;
    (0,react.useEffect)(function() {
        (0,cms/* fetchAPI */.I)("/courses", {
            populate: {
                metrics: {
                    populate: "*"
                }
            },
            filters: {
                slug: {
                    $eq: slug
                }
            }
        }, locale).then(function(res) {
            setData(res === null || res === void 0 ? void 0 : res.data[0]);
        }).catch(function() {
            setError(true);
        }).finally(function() {
            setPending(null);
        });
    }, [
        locale,
        slug
    ]);
    if (pending) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CourseSkeleton, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (CourseInfo_module_default()).top,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (CourseInfo_module_default()).heading,
                        children: [
                            isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                                color: "grey",
                                className: (CourseInfo_module_default()).label,
                                appearance: "smaller",
                                children: t("selected_course")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading4 */.k8, {
                                className: (CourseInfo_module_default()).title,
                                color: "light",
                                children: error ? t("undefined_course") : data.title
                            })
                        ]
                    }),
                    isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Action */.aU, {
                        className: (CourseInfo_module_default()).button,
                        onClick: onDeleteCourse(slug),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                            name: "close_white"
                        })
                    })
                ]
            }),
            availableMetrics === null || availableMetrics === void 0 ? void 0 : availableMetrics.map(function(metrics) {
                var Block = METRICS_MAPPING[metrics.dataKey];
                var styleKey = metrics.dataKey.replace(/([A-Z])/g, "-$1").toLowerCase();
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileLabel, {
                            label: metrics.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (CourseInfo_module_default())[metrics.template],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (CourseInfo_module_default())[styleKey],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                    metrics: data.metrics,
                                    dataKey: metrics.dataKey
                                })
                            })
                        })
                    ]
                }, metrics.title);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* PageLink */.H_, {
                directory: "programs",
                slug: slug,
                className: (CourseInfo_module_default()).link,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* RenderIf */.$b, {
                        viewMode: ViewMode/* VIEW_MODES.MOBILE */.nY.MOBILE
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                        color: "dark",
                        appearance: "bold",
                        uppercase: true,
                        className: (CourseInfo_module_default()).more,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonView, {})
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/widgets/content/Content064/CourseInfo/index.js


// EXTERNAL MODULE: ./src/components/widgets/content/Content064/MobileCoursesList/MobileCoursesList.module.scss
var MobileCoursesList_module = __webpack_require__(39788);
var MobileCoursesList_module_default = /*#__PURE__*/__webpack_require__.n(MobileCoursesList_module);
;// CONCATENATED MODULE: ./src/components/widgets/content/Content064/MobileCoursesList/MobileCoursesList.jsx





var MobileCoursesList = function() {
    var t = (0,translations/* useTranslation */.$)().t;
    var ref = useWidgetContent(), unavailableCourses = ref.unavailableCourses, onDeleteCourse = ref.onDeleteCourse;
    return unavailableCourses.map(function(param) {
        var id = param.id, title = param.title, slug = param.slug;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (MobileCoursesList_module_default()).block,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                            color: "grey",
                            className: (MobileCoursesList_module_default()).label,
                            appearance: "smaller",
                            children: t("selected_course")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading4 */.k8, {
                            color: "light",
                            children: title
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Action */.aU, {
                    className: (MobileCoursesList_module_default()).button,
                    onClick: onDeleteCourse(slug),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                        name: "close_white"
                    })
                })
            ]
        }, id);
    });
};

;// CONCATENATED MODULE: ./src/components/widgets/content/Content064/MobileCoursesList/index.js


// EXTERNAL MODULE: ./src/components/widgets/content/Content064/GridBlock/GridBlock.module.scss
var GridBlock_module = __webpack_require__(71400);
var GridBlock_module_default = /*#__PURE__*/__webpack_require__.n(GridBlock_module);
;// CONCATENATED MODULE: ./src/components/widgets/content/Content064/GridBlock/GridBlock.jsx










var GridBlock = function(param) {
    var param = param !== null ? param : _throw(new TypeError("Cannot destructure undefined"));
    var mode = (0,ViewMode/* useViewMode */.mJ)().mode;
    var t = (0,translations/* useTranslation */.$)().t;
    var ref = useWidgetContent(), selectedCourses = ref.selectedCourses, availableMetrics = ref.availableMetrics;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* RenderIf */.$b, {
                viewMode: ViewMode/* VIEW_MODES.MOBILE */.nY.MOBILE,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileCoursesList, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonAdd, {
                        label: t("add_more_course"),
                        className: (GridBlock_module_default()).button
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (GridBlock_module_default()).wrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (GridBlock_module_default()).list,
                    style: {
                        gridTemplate: mode === "desktop" ? "repeat(".concat(availableMetrics.length + 2, ", auto) / 240px repeat(").concat(selectedCourses.length, ", 430px)") : "repeat(".concat((availableMetrics.length + 1) * 2, ", auto) / repeat(").concat(selectedCourses.length, ", 245px)")
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* RenderIf */.$b, {
                            viewMode: ViewMode/* VIEW_MODES.DESKTOP */.nY.DESKTOP,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                                    className: (GridBlock_module_default()).empty,
                                    children: ""
                                }),
                                availableMetrics.map(function(param) {
                                    var title = param.title;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (GridBlock_module_default()).title,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                                            color: "dark",
                                            appearance: "bold",
                                            children: t(title)
                                        })
                                    }, title);
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                                    className: (GridBlock_module_default()).empty,
                                    children: ""
                                })
                            ]
                        }),
                        selectedCourses.map(function(slug) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CourseInfo, {
                                slug: slug
                            }, slug);
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/widgets/content/Content064/GridBlock/index.js


;// CONCATENATED MODULE: ./src/components/widgets/content/Content064/BlockType.jsx




var BlockType = function() {
    var selectedCourses = useWidgetContent().selectedCourses;
    return selectedCourses.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultBlock, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(GridBlock, {});
};

// EXTERNAL MODULE: ./src/components/widgets/content/Content064/Content064.module.scss
var Content064_module = __webpack_require__(73766);
var Content064_module_default = /*#__PURE__*/__webpack_require__.n(Content064_module);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
;// CONCATENATED MODULE: ./src/features/sessionStorage/sessionStorage.js
function setSessionStorage(key) {
    var data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    sessionStorage.setItem(key, JSON.stringify(data));
}
function getSessionStorage(key) {
    return sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem(key);
}

// EXTERNAL MODULE: ./src/features/widgets/index.js + 3 modules
var widgets = __webpack_require__(68642);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/shared/contexts/PageData/index.js + 3 modules
var PageData = __webpack_require__(65202);
// EXTERNAL MODULE: ./src/shared/hooks/index.js + 6 modules
var hooks = __webpack_require__(87367);
;// CONCATENATED MODULE: ./src/components/widgets/content/Content064/Content064.Provider.js









var STORAGE_KEY = "__comparison__selected__courses";
var WidgetProvider = function(param) {
    var children = param.children, payload = param.payload;
    var locale = (0,router.useRouter)().locale;
    var instanceId = (0,widgets/* buildWidgetInstanceId */.G1)("064", payload.id);
    var courses = (0,PageData/* useCollectedData */.M)(instanceId, [
        {
            name: "courses",
            defaultValue: []
        }, 
    ]).courses;
    var config = (0,react.useMemo)(function() {
        var ref;
        return (ref = payload === null || payload === void 0 ? void 0 : payload.config) !== null && ref !== void 0 ? ref : [];
    }, [
        payload
    ]);
    var ref = (0,react.useState)([]), selectedCourses = ref[0], setSelectCourses = ref[1];
    var availableCourses = (0,react.useMemo)(function() {
        return courses.filter(function(param) {
            var slug = param.slug;
            return !selectedCourses.includes(slug);
        });
    }, [
        courses,
        selectedCourses
    ]);
    var unavailableCourses = (0,react.useMemo)(function() {
        return courses.filter(function(param) {
            var slug = param.slug;
            return selectedCourses.includes(slug);
        });
    }, [
        courses,
        selectedCourses
    ]);
    var ref1 = (0,hooks/* useToggle */.OT)(), opened = ref1.opened, onOpen = ref1.onOpen, onClose = ref1.onClose;
    var onSelectCourse = (0,react.useCallback)(function(slug) {
        return function() {
            setSelectCourses(function(current) {
                return (0,_to_consumable_array/* default */.Z)(current).concat([
                    slug
                ]);
            });
            onClose();
            setSessionStorage(STORAGE_KEY, (0,_to_consumable_array/* default */.Z)(selectedCourses).concat([
                slug
            ]));
        };
    }, [
        onClose,
        selectedCourses
    ]);
    var onDeleteCourse = (0,react.useCallback)(function(slug) {
        return function() {
            setSelectCourses(function(current) {
                return current.filter(function(item) {
                    return item !== slug;
                });
            });
            setSessionStorage(STORAGE_KEY, selectedCourses.filter(function(item) {
                return item !== slug;
            }));
        };
    }, [
        selectedCourses
    ]);
    (0,react.useEffect)(function() {
        var storedData = getSessionStorage(STORAGE_KEY);
        if (storedData !== null) setSelectCourses(JSON.parse(storedData));
    }, []);
    var isAddingDisabled = (0,react.useMemo)(function() {
        return availableCourses.length === 0;
    }, [
        availableCourses.length
    ]);
    var availableMetrics = (0,react.useMemo)(function() {
        return config === null || config === void 0 ? void 0 : config.filter(function(param) {
            var enabled = param.enabled;
            return Boolean(enabled);
        });
    }, [
        config
    ]);
    var value = {
        locale: locale,
        courses: courses,
        availableCourses: availableCourses,
        unavailableCourses: unavailableCourses,
        selectedCourses: selectedCourses,
        opened: opened,
        onOpen: onOpen,
        onClose: onClose,
        onSelectCourse: onSelectCourse,
        onDeleteCourse: onDeleteCourse,
        isAddingDisabled: isAddingDisabled,
        availableMetrics: availableMetrics
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetContent.Provider, {
        value: value,
        children: children
    });
};

// EXTERNAL MODULE: ./src/components/widgets/content/Content064/ModalCoursesList/ModalCoursesList.module.scss
var ModalCoursesList_module = __webpack_require__(34416);
var ModalCoursesList_module_default = /*#__PURE__*/__webpack_require__.n(ModalCoursesList_module);
;// CONCATENATED MODULE: ./src/components/widgets/content/Content064/ModalCoursesList/ModalCoursesList.jsx





var ModalCoursesList = function(param) {
    var param = param !== null ? param : _throw(new TypeError("Cannot destructure undefined"));
    var ref = useWidgetContent(), opened = ref.opened, availableCourses = ref.availableCourses, onSelectCourse = ref.onSelectCourse, onClose = ref.onClose;
    return opened ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ModalWrapper */.AB, {
        onCloseModal: onClose,
        appearance: "course-list",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (ModalCoursesList_module_default()).list,
            children: availableCourses.map(function(param) {
                var id = param.id, title = param.title, slug = param.slug;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Action */.aU, {
                    className: (ModalCoursesList_module_default()).button,
                    onClick: onSelectCourse(slug),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading6 */.Cd, {
                        className: (ModalCoursesList_module_default()).item,
                        color: "dark",
                        appearance: "bold",
                        children: title
                    })
                }, id);
            })
        })
    }) : null;
};

;// CONCATENATED MODULE: ./src/components/widgets/content/Content064/ModalCoursesList/index.js


;// CONCATENATED MODULE: ./src/components/widgets/content/Content064/Content064.jsx








var Content064 = function(param) {
    var payload = param.payload;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(WidgetProvider, {
        payload: payload,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Content064_module_default()).wrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Content064_module_default()).container,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* RenderIf */.$b, {
                            viewMode: ViewMode/* VIEW_MODES.DESKTOP */.nY.DESKTOP,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonAdd, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockType, {})
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalCoursesList, {})
        ]
    });
};
/* harmony default export */ var Content064_Content064 = (Content064);


/***/ }),

/***/ 98449:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"ButtonAdd_button__Ko86N","circle":"ButtonAdd_circle__PNpge","icon":"ButtonAdd_icon__5a5xJ","label":"ButtonAdd_label__6GZ6B"};

/***/ }),

/***/ 73766:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content064_wrapper__D5SNl","container":"Content064_container__tWqqx"};

/***/ }),

/***/ 42968:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"top":"CourseInfo_top__jgcOT","button":"CourseInfo_button__Qx_3k","grey":"CourseInfo_grey__SMINg","light":"CourseInfo_light__eGre_","suits-to":"CourseInfo_suits-to__x43mU","diploma":"CourseInfo_diploma__zl8Ml","duration":"CourseInfo_duration__mgyu6","program-price":"CourseInfo_program-price__bZbGU","program-price__block":"CourseInfo_program-price__block__Cvgeo","program-price__title":"CourseInfo_program-price__title__PNM_i","advantages":"CourseInfo_advantages__kD0qt","results":"CourseInfo_results__3KvWJ","international-module":"CourseInfo_international-module__9smdz","link":"CourseInfo_link__HZrn4","more":"CourseInfo_more__Rn2Cb","empty":"CourseInfo_empty__5e6p4","title":"CourseInfo_title__AgigO","subtitle":"CourseInfo_subtitle__TVQbH"};

/***/ }),

/***/ 30974:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"top":"CourseSkeleton_top__H4DFV","title":"CourseSkeleton_title___4r88","block":"CourseSkeleton_block__rdZS2","big":"CourseSkeleton_big__WRjSP","small":"CourseSkeleton_small__SEgzA","divider":"CourseSkeleton_divider__gdSL0","testbutton":"CourseSkeleton_testbutton__JeX70","link":"CourseSkeleton_link__0Nc2v"};

/***/ }),

/***/ 72304:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DefaultBlock_wrapper___Nw3v","blocks":"DefaultBlock_blocks__3C1by","title":"DefaultBlock_title__qgEaE","list":"DefaultBlock_list__zD59Z","item":"DefaultBlock_item__w2xpu"};

/***/ }),

/***/ 71400:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"list":"GridBlock_list__oCTUQ","title":"GridBlock_title__m5_UN","empty":"GridBlock_empty__RnVdu","wrapper":"GridBlock_wrapper__RB_8S","button":"GridBlock_button__oLvlg"};

/***/ }),

/***/ 39788:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"block":"MobileCoursesList_block__lkX4U","button":"MobileCoursesList_button__grHk5","label":"MobileCoursesList_label__2lojb"};

/***/ }),

/***/ 34416:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"list":"ModalCoursesList_list__Z_baU","button":"ModalCoursesList_button__C989E","item":"ModalCoursesList_item__Ndkpx"};

/***/ })

}]);